import {
	RainbowKitProvider,
	connectorsForWallets,
	darkTheme,
	lightTheme,
} from "@rainbow-me/rainbowkit";
import {
	metaMaskWallet,
	okxWallet,
	walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { useEffect, useState } from "react";
import { WagmiProvider } from "wagmi";
import { http, createConfig } from "wagmi";
import {
	arbitrum,
	base,
	baseSepolia,
	bsc,
	mainnet,
	optimism,
	optimismSepolia,
	polygon,
} from "wagmi/chains";

import "@rainbow-me/rainbowkit/styles.css";

const connectors = connectorsForWallets(
	[
		{
			groupName: "Recommended",
			wallets: [metaMaskWallet, okxWallet, walletConnectWallet],
		},
	],
	{
		appName: "AIFK",
		projectId: "08f6d2bc19b8bc456e94a77e67916000",
	},
);

const config = createConfig({
	connectors,
	chains: [
		baseSepolia,
		base,
		optimism,
		arbitrum,
		polygon,
		bsc,
		mainnet,
		optimismSepolia,
	],
	transports: {
		[baseSepolia.id]: http(),
		[base.id]: http(),
		[optimism.id]: http(),
		[arbitrum.id]: http(),
		[polygon.id]: http(),
		[bsc.id]: http(),
		[mainnet.id]: http(),
		[optimismSepolia.id]: http(),
	},
	ssr: false,
});

// const queryClient = new QueryClient();

export default function Web3Provider({
	children,
}: {
	children: React.ReactNode;
}) {
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) {
		return null;
	}

	return (
		<WagmiProvider config={config}>
			<RainbowKitProvider
				modalSize="compact"
				theme={{
					lightMode: lightTheme(),
					darkMode: darkTheme(),
				}}
			>
				{children}
			</RainbowKitProvider>
		</WagmiProvider>
	);
}
